import {
  App,
  VerifySmsCodeMfaRequest,
  routes as allRoutes,
  fullEndpoints,
} from "@songtradr-sso/shared/common";
import { staticText as sharedText } from "@songtradr-sso/shared/frontend";
import { staticText } from "../../../shared/statics/static-text";
import { Api } from "../../../shared/utils/api.utils";

// TEXT
export const text = {
  ...staticText.mfa.sms.verify,
  shared: { inputs: sharedText.inputs },
};

// STYLES

// DATA
export const verifySmsCode = (r: VerifySmsCodeMfaRequest) => {
  return Api.post(endpoints.verifySmsCode, r).then((resp) => resp.data);
};

// TYPES

// CONSTANTS
export const routes = allRoutes[App.Core];
const endpoints = fullEndpoints[App.Core].mfa;

// FUNCTIONS

// ASSETS
